import { render, staticRenderFns } from "./languages-btns.vue?vue&type=template&id=18b2d09a&"
import script from "./languages-btns.vue?vue&type=script&lang=ts&"
export * from "./languages-btns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports